'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * StageStories
 *
 * @author Srdan Turudic <srdan.turudic@namics.com>
 */
T.Module.StageStories = T.createModule({

	_selectors: {
		slides: '[data-js-m-stage-stories__slide]',
		images: '[data-js-a-image__img]',
		timelineIndex: 'timeline-index',
		fadeOut: 'm-stage-stories__slide--fadeout',
		fadeIn: 'm-stage-stories__slide--fadein',
		slideUp: 'm-stage-stories__data-buttons--up',
		slideDown: 'm-stage-stories__data-buttons--down',
		timelineItem: 'm-stage-stories__timeline-item',
		slide: 'm-stage-stories__slide',
		loadMore: 'm-stage-stories__load-more',
		timelineLink: 'm-stage-stories__timeline-item--desktop',
		template: '[data-js-stories-slides__template]',
		readMore: 'a-button--read-more',
		stageData: 'm-stage-stories__data',
		stageFooter: 'm-stage-stories__footer',
		stageImage: 'a-image__img',
		exploreStories: 'm-stage-stories__explore',
		storyDetail: 'm-stage-stories__detail',
		sliderStories: 'm-slider--stories',
		pageFooter: 'l-outer--footer',
		footerTagList: 'l-outer--dark',
		stickyContact: 'm-sticky-contact',
		mainContainer: 'l-stories',
		storyCommentContainer: 'story-comment-container',
		languageNavigation: 'm-navigation-language',
		languageNavigationLink: 'a-link--navigation-language',
		slideWrapper: 'm-stage-stories__slide-wrapper',
		commentList: 'o-comments__list'
	},

	_eventNames: {
		button: 'slide-button',
		interval: 'slide-interval',
		autoplay: 'slide-autoplay',
		slideUp: 'm-stage-stories__data-buttons--up',
		slideDown: 'm-stage-stories__data-buttons--down'
	},

	_states: {
		timelineActive: 'm-stage-stories__timeline-item--active',
		elementHidden: 'm-stage-stories--hidden',
		stageSmall: 'm-stage-stories--small',
		zoomImage: 'a-image__img--zoom',
		detailOpen: 'm-stage-stories__detail--open',
		sliderDetailOpen: 'm-slider--stories__detail--open',
		sliderScroll: 'm-slider--stories-scroll'
	},

	apiQueryBatchSize: 10,

	apiQueryOperationTypeInitial: 'apiQueryOperationTypeInitial',
	apiQueryOperationTypeNext: 'apiQueryOperationTypeNext',
	apiQueryOperationTypePrevious: 'apiQueryOperationTypePrevious',

	start: function start(resolve) {
		this.resolve = resolve;
		this.$ctx = $(this._ctx);

		this.storyChangeFadeInMilliseconds = 2000;
		this.storyOpenFadeInMilliseconds = 500;

		this.stageTitle = this.$ctx.data('stage-title');
		this.stageUrl = this.$ctx.data('stage-url');

		this.tagName = this.$ctx.data('tag-name');
		this.isOpenStory = this.$ctx.data('is-open');
		this.initialOffset = this.$ctx.data('initial-offset');
		this.langcode = this.$ctx.data('langcode');

		var commentPostedUrlParameterName = this.$ctx.data('comment-posted-url-parameter-name');
		var urlParameters = new URLSearchParams(window.location.search);
		this.commentPosted = urlParameters.get(commentPostedUrlParameterName);

		if (this.commentPosted) {
			this.shouldJumpToComments = true;
		} else {
			this.shouldJumpToComments = false;
		}

		this.requestUrl = '';

		this.slideData = undefined;
		this.storyCommentData = undefined;
		this.unregisterDetailTerrificModules = [];

		this.resetSliderState();
		this.oldTimelineIndex = undefined;
		this.timelineIndex = 1;
		this.currentOffset = 0;

		if (this.initialOffset) {
			this.currentOffset = this.initialOffset;
		}

		if (this.isHistoryActiveSlideIndexSet()) {
			this.currentOffset = window.history.state.activeOffset;
			this.timelineIndex = window.history.state.activeOffset + 1;
		}

		this.$template = this.$ctx.find(this._selectors.template);
		// TODO: Check why start method is executed after next slides are queried. And prevent it.
		this.queryForSlidesAndUpdateDotTemplate(this.resolve, this.apiQueryOperationTypeInitial);

		// Add browser navigation back/forward event listener.
		window.onpopstate = this.reloadPageOnHistoryNavigation.bind(this);
		/* Add history state flag to current history entry.
  So that the first page that was loaded by the user is also reloaded when
  the user navigates to it by browser back/forward buttons. */
		this.replaceInitialHistoryState();

		resolve();
	},
	resetSliderState: function resetSliderState() {
		this.isSliderStylingInitialized = false;
	},


	/**
  * Checks whether the application is currently run locally so the mock server
  * URL can be used.
  *
  * @returns {boolean} true if on localhost.
  **/
	isFrontend: function isFrontend() {
		return location.hostname === 'localhost';
	},
	isHistoryActiveSlideIndexSet: function isHistoryActiveSlideIndexSet() {
		var isHistoryActiveSlideIndexSet = false;
		if (_typeof(window.history.state) !== undefined && window.history.state !== null) {
			if (typeof window.history.state.activeOffset === 'number') {
				isHistoryActiveSlideIndexSet = true;
			}
		}

		return isHistoryActiveSlideIndexSet;
	},


	// eslint-disable-next-line complexity
	getSlides: function getSlides(template, resolve, operationType) {
		var _this = this;

		var apiQueryOffset = undefined;
		var doExecuteApiRequest = true;

		if (operationType === this.apiQueryOperationTypeInitial) {
			apiQueryOffset = this.currentOffset;
		} else if (operationType === this.apiQueryOperationTypeNext) {
			apiQueryOffset = this.currentOffset;

			// Don't make an AJAX if slides were already loaded previously.
			if (typeof this.slideData.slides[apiQueryOffset] !== 'undefined') {
				doExecuteApiRequest = false;
			}
		} else if (operationType === this.apiQueryOperationTypePrevious) {
			apiQueryOffset = this.currentOffset - this.apiQueryBatchSize + 1;

			// Don't make an AJAX if slides were already loaded previously.
			if (typeof this.slideData[apiQueryOffset] !== 'undefined') {
				doExecuteApiRequest = false;
			}
		} else {
			// eslint-disable-next-line
			console.error('Invalid operationType in getSlides!');
		}

		if (doExecuteApiRequest) {
			// Fade out image before executing AJAX request.
			if (operationType !== this.apiQueryOperationTypeInitial) {
				this.fadeOutActiveTimelineItem(this.oldTimelineIndex);
			}

			this.performApiRequest(apiQueryOffset, template, resolve);
		} else {
			this.fadeOutActiveTimelineItem(this.oldTimelineIndex, function () {
				// Render new template after fade out.
				_this.renderTemplate(apiQueryOffset, template, resolve, false);
			});
		}
	},


	/**
  * Check if an API Request is necessary or if the slides are already cached.
  *
  * @param {number} offset The offset.
  * @returns {boolean} Whether a request is needed.
  **/
	isRequestNeccessary: function isRequestNeccessary(offset) {
		if (!this.slideData) {
			return true;
		}

		var slideCount = this.slideData.slides.length - 1 || 0;
		var slideCountWithOffset = slideCount + this.initialOffset;

		return slideCount < slideCountWithOffset || offset > slideCount;
	},


	/**
  * Renders the template with the current slide data.
  *
  * @param {number} offset The offset.
  * @param {function} template The template to be rendered.
  * @param {function} resolve The resolve function.
  * @param {boolean} first Is it the first initialization?
  * @returns {void}
  **/
	renderTemplate: function renderTemplate(offset, template, resolve, first) {
		this.slideData.currentOffset = offset;
		var renderedDotTemplate = this.renderDotTemplate(template, this.slideData);
		this.initializeSlider(resolve, renderedDotTemplate, first);
	},
	performApiRequest: function performApiRequest(apiQueryOffset, template, resolve) {
		var _this2 = this;

		if (!this.isRequestNeccessary(apiQueryOffset)) {
			return this.renderTemplate(apiQueryOffset, template, resolve, false);
		}

		if (this.isFrontend()) {
			this.requestUrl = 'http://localhost:3000/slides/' + apiQueryOffset;
			// If no tagName is given, it is the home stage.
		} else if (this.tagName === undefined || this.tagName === '') {
			this.requestUrl = '/' + this.langcode + '/api/stories/' + apiQueryOffset + '?_format=json';
		} else {
			this.requestUrl = '/' + this.langcode + '/api/stories-with-tag/' + this.tagName + '/' + apiQueryOffset + '?_format=json';
		}

		$.ajax({
			method: 'GET',
			url: this.requestUrl,
			dataType: 'json',
			success: function success(response) {
				response = _this2.mapResponse(response);
				_this2.updateSlides(response, apiQueryOffset, template, resolve);
			},
			error: function error() {
				if (_this2.isFrontend()) {
					// eslint-disable-next-line
					console.warn('The API request failed! Did you start the Mock server  with \'npm run mock\'?');
				}
			}
		});
	},


	/**
  * Map the slides to an array in every case.
  *
  * @param {Object} response The response.
  * @returns {Object} The response with slides as an array.
  **/
	mapResponse: function mapResponse(response) {
		if (!(response.slides instanceof Array)) {
			response.slides = Object.values(response.slides);
		}

		return response;
	},


	/**
  * Create slide data for first time.
  * Else add slides to slide data if slides already exist.
  * Slides can be merged, since they are indexed by offset.
  *
  * @param {Object} newSlideData The new slide data from Backend.
  * @param {number} currentOffset The current offset.
  * @param {function} template The template.
  * @param {function} resolve The resolve callback.
  * @returns {void}
  **/
	updateSlides: function updateSlides(newSlideData, currentOffset, template, resolve) {
		var isFirstInitialization = undefined;

		if (typeof this.slideData === 'undefined') {
			this.slideData = newSlideData;
			this.slideData.currentOffset = this.slideData.currentOffset - this.initialOffset;
			this.isSlideDataInitialized = true;
			isFirstInitialization = true;
		} else {
			this.slideData.currentOffset = currentOffset;
			// Push either to start of end, depending on current offsets.
			if (this.initialOffset > this.slideData.currentOffset) {
				this.slideData.slides = [].concat(_toConsumableArray(newSlideData.slides), _toConsumableArray(this.slideData.slides));
			} else {
				this.slideData.slides = [].concat(_toConsumableArray(this.slideData.slides), _toConsumableArray(newSlideData.slides));
			}
			isFirstInitialization = false;
			this.initialOffset = currentOffset;
		}

		this.renderTemplate(this.slideData.currentOffset, template, resolve, isFirstInitialization);
	},


	/**
  * Copy slideData to avoid modifying the original.
  *
  * Only display max. 10 slides from currentOffset and after it.
  *
  * The array must be indexed by an index starting with zero, because
  * otherwise for loops won't work on it.
  *
  * @param {function} templateMethod The template method.
  * @param {function} slideData The slide data.
  * @returns {function} The template.
  **/
	renderDotTemplate: function renderDotTemplate(templateMethod, slideData) {
		var dotTemplateData = $.extend(true, {}, slideData);
		// Extracts the slides to be displayed, from current offset
		// to maximum, but not more than the max display count of 10.
		dotTemplateData.slides = dotTemplateData.slides.slice(slideData.currentOffset, Math.min(10, dotTemplateData.slides.length - slideData.currentOffset) + slideData.currentOffset);
		dotTemplateData.slides = this.convertSlidesObjectToArrayIndexedByZero(dotTemplateData.slides);
		return templateMethod(dotTemplateData);
	},
	convertSlidesObjectToArrayIndexedByZero: function convertSlidesObjectToArrayIndexedByZero(slidesObject) {
		var slidesArray = [];
		// eslint-disable-next-line no-restricted-syntax
		for (var slideIndex in slidesObject) {
			if (Object.prototype.hasOwnProperty.call(slidesObject, slideIndex)) {
				slidesArray.push(slidesObject[slideIndex]);
			}
		}

		return slidesArray;
	},
	initializeSlider: function initializeSlider(resolve, slidesMarkup, isFirstInitialization) {
		this.resetSliderState();

		this.$slideWrapper = $('.' + this._selectors.slideWrapper);
		this.$slideWrapper.empty();
		this.$slideWrapper.append(slidesMarkup);

		this.$slides = this.$ctx.find(this._selectors.slides);
		this.$slideUp = this.$ctx.find('.' + this._selectors.slideUp);
		this.$slideDown = this.$ctx.find('.' + this._selectors.slideDown);
		this.$timelineLink = this.$ctx.find('.' + this._selectors.timelineLink);
		this.$readMore = this.$ctx.find('.' + this._selectors.readMore);
		this.$stageData = this.$ctx.find('.' + this._selectors.stageData);
		this.$stageFooter = this.$ctx.find('.' + this._selectors.stageFooter);
		this.$stageImage = this.$ctx.find('.' + this._selectors.stageImage);
		this.$exploreStories = $('.' + this._selectors.exploreStories);
		this.$storyDetail = $('.' + this._selectors.storyDetail);
		this.$sliderStories = $('.' + this._selectors.sliderStories);
		this.$pageFooter = $('.' + this._selectors.pageFooter);
		this.$footerTagList = $('.' + this._selectors.footerTagList);
		this.$stickyContact = $('.' + this._selectors.stickyContact);
		this.$mainContainer = $('.' + this._selectors.mainContainer);
		this.$slide = $('.' + this._selectors.slide);
		this.$languageNavigationLinks = $('.' + this._selectors.languageNavigation + '.' + this._selectors.languageNavigationLink);

		this.$pageFooter.hide();
		this.$footerTagList.hide();
		this.$stickyContact.remove();

		// Do not initialize stage if no stories exist.
		// Use Object.keys, because this.slideData.slides can be an array or object.
		if (Object.keys(this.slideData.slides).length > 0) {
			this.initStories(isFirstInitialization);
		}
	},


	/**
  * Initialize the stories if they exist.
  *
  * @param {boolean} isFirstInitialization Is it the first initialization?
  * @returns {void}
  **/
	initStories: function initStories(isFirstInitialization) {
		this.replaceDetailMarkupWithCurrentSlideMarkup();

		this.$slideUp.on('click', this.previousSlide.bind(this));
		this.$slideDown.on('click', this.nextSlide.bind(this));
		this.$timelineLink.on('click', this.handleTimelineLink.bind(this));
		this.$readMore.on('click', this.openDetail.bind(this));
		this.$exploreStories.on('click', this.closeDetail.bind(this));

		// Show current slide.
		var playSlideFadeInAnimation = false;
		if (isFirstInitialization !== 'undefined') {
			playSlideFadeInAnimation = !isFirstInitialization;
		}

		if (playSlideFadeInAnimation) {
			this.fadeInNextTimelineItem(this.timelineIndex);
		} else {
			var $currentSlide = $('.' + this._selectors.slide + '.index-' + this.timelineIndex);
			$currentSlide.show();
		}

		if (!this.isSliderStylingInitialized) {
			this.setInitialStyles();
			this.isSliderStylingInitialized = true;
		}

		if (this.isOpenStory) {
			this.openDetail();
		}
	},
	reloadPageOnHistoryNavigation: function reloadPageOnHistoryNavigation(event) {
		/* Reload page if user navigates back/forward to a browser history entry that was created with JavaScript.
  So that the correct state ist loaded. */
		if (_typeof(event.state) !== undefined) {
			if (_typeof(event.state.navigationType) !== undefined) {
				if (event.state.navigationType === 'javascript') {
					window.location.reload();
				}
			}
		}
	},
	queryForSlidesAndUpdateDotTemplate: function queryForSlidesAndUpdateDotTemplate(resolve, operationType) {
		var template = doT.template(this.$template.html());
		this.getSlides(template, resolve, operationType);
	},
	setInitialStyles: function setInitialStyles() {
		this.updateArrowUpDownDisplay();

		// Set current slide sidebar item as active.
		$('.' + this._selectors.slide + '.index-' + this.timelineIndex).find('.' + this._selectors.timelineItem + '.index-' + this.timelineIndex).addClass(this._states.timelineActive);
	},
	updateArrowUpDownDisplay: function updateArrowUpDownDisplay() {
		// Hide slide up arrow if current slide is the first story.
		if (this.getCurrentSlide().isFirst) {
			this.hideArrowUp();
		} else {
			this.showArrowUp();
		}

		// Hide slide up arrow if current slide is the first story.
		if (this.getCurrentSlide().isLast) {
			this.hideArrowDown();
		} else {
			this.showArrowDown();
		}
	},
	getCurrentSlide: function getCurrentSlide() {
		var offset = this.currentOffset - this.initialOffset;
		return this.slideData.slides[offset];
	},
	getPreviousSlide: function getPreviousSlide() {
		var offset = this.currentOffset - this.initialOffset - 1;
		return this.slideData.slides[offset];
	},
	getNextSlide: function getNextSlide() {
		var offset = this.currentOffset - this.initialOffset + 1;
		return this.slideData.slides[offset];
	},
	updateActiveTimelineItemDisplay: function updateActiveTimelineItemDisplay(currentSlideTimelineIndex, nextSlideTimelineIndex) {
		this.fadeOutActiveTimelineItem(currentSlideTimelineIndex);
		this.fadeInNextTimelineItem(nextSlideTimelineIndex);
	},
	fadeOutActiveTimelineItem: function fadeOutActiveTimelineItem(currentSlideTimelineIndex, fadeOutCompletedCallback) {
		var $currentSlide = $('.' + this._selectors.slide + '.index-' + currentSlideTimelineIndex);

		$('.' + this._selectors.slide).removeClass(this._selectors.fadeOut);
		$('.' + this._selectors.slide).find('' + this._selectors.timelineItem).removeClass(this._selectors.timelineActive);

		$currentSlide.addClass(this._selectors.fadeOut);
		if (typeof fadeOutCompletedCallback === 'function') {
			this.$slides.fadeOut(this.storyChangeFadeInMilliseconds, fadeOutCompletedCallback);
		} else {
			this.$slides.fadeOut(this.storyChangeFadeInMilliseconds);
		}
	},
	fadeInNextTimelineItem: function fadeInNextTimelineItem(nextSlideTimelineIndex) {
		var $nextSlide = $('.' + this._selectors.slide + '.index-' + nextSlideTimelineIndex);

		$nextSlide.find('.' + this._selectors.timelineItem + '.index-' + nextSlideTimelineIndex).addClass(this._states.timelineActive);

		$nextSlide.fadeIn(this.storyChangeFadeInMilliseconds);
	},
	showArrowUp: function showArrowUp() {
		$('.' + this._selectors.slideUp).removeClass(this._states.elementHidden);
	},
	hideArrowUp: function hideArrowUp() {
		$('.' + this._selectors.slideUp).addClass(this._states.elementHidden);
	},
	showArrowDown: function showArrowDown() {
		$('.' + this._selectors.slideDown).removeClass(this._states.elementHidden);
	},
	hideArrowDown: function hideArrowDown() {
		$('.' + this._selectors.slideDown).addClass(this._states.elementHidden);
	},
	showLoadMore: function showLoadMore() {
		$('.' + this._selectors.loadMore).show();
	},
	hideLoadMore: function hideLoadMore() {
		$('.' + this._selectors.loadMore).hide();
	},
	replaceDetailMarkupWithCurrentSlideMarkup: function replaceDetailMarkupWithCurrentSlideMarkup() {
		// Stop Terrific modules of previous Story detail content.
		[].forEach.call(this.unregisterDetailTerrificModules, function (unregisterDetailTerrificModule) {
			unregisterDetailTerrificModule();
		});

		this.$storyDetail.empty();
		var markup = this.getCurrentSlide().detailMarkup;
		this.$storyDetail.append(markup);

		var storyContainer = document.querySelector('.' + this._selectors.storyDetail);
		this.unregisterDetailTerrificModules = this.initializeTerrificModulesInContainer(storyContainer);
	},
	initializeTerrificModulesInContainer: function initializeTerrificModulesInContainer(container) {
		var unregisterModulesMethods = [];
		if (container) {
			// Initialize all components inside container.
			var modules = container.querySelectorAll('*[data-t-name]');
			[].forEach.call(modules, function (moduleContext) {
				var dataName = moduleContext.getAttribute('data-t-name');
				var dataDecorator = moduleContext.getAttribute('data-t-decorator');

				var terrificModule = undefined;
				if (dataDecorator) {
					terrificModule = window.terrificApp.registerModule(moduleContext, dataName, dataDecorator);
				} else {
					terrificModule = window.terrificApp.registerModule(moduleContext, dataName);
				}

				if (terrificModule) {
					window.terrificApp.start([terrificModule]);

					unregisterModulesMethods.push(function () {
						var registeredModules = {};
						registeredModules[moduleContext.getAttribute('data-t-id')] = terrificModule;
						window.terrificApp.stop(registeredModules);
						window.terrificApp.unregisterModules(registeredModules);
					});
				}
			});

			return unregisterModulesMethods;
		}
	},
	previousSlide: function previousSlide() {
		var newTimelineIndex = this.timelineIndex - 1;
		this.changeActiveTimelineItem(newTimelineIndex);
	},
	nextSlide: function nextSlide() {
		var newTimelineIndex = this.timelineIndex + 1;
		this.changeActiveTimelineItem(newTimelineIndex);
	},
	handleTimelineLink: function handleTimelineLink(event) {
		var newTimelineIndex = event.target.dataset.timelineIndex;
		this.changeActiveTimelineItem(newTimelineIndex);
	},
	changeActiveTimelineItem: function changeActiveTimelineItem(newTimelineIndex) {
		var indexChange = newTimelineIndex - this.timelineIndex;
		this.currentOffset = this.currentOffset + indexChange;
		this.oldTimelineIndex = this.timelineIndex;

		// Load more slides if necessary.
		var isBeforeStartOfTimeline = newTimelineIndex === 0;

		var isOldSlideFirstStory = false;
		var previousSlide = this.getPreviousSlide();
		if (typeof previousSlide !== 'undefined') {
			isOldSlideFirstStory = this.getPreviousSlide().isFirst;
		}

		var isOverEndOfTimeline = newTimelineIndex === this.apiQueryBatchSize + 1;

		var isOldSlideLastStory = false;
		var nextSlide = this.getNextSlide();
		if (typeof nextSlide !== 'undefined') {
			isOldSlideLastStory = this.getNextSlide().isLast;
		}

		if (isBeforeStartOfTimeline && !isOldSlideFirstStory) {
			this.queryForSlidesAndUpdateDotTemplate(this.resolve, this.apiQueryOperationTypePrevious);
			// Set timeline index to last item.
			newTimelineIndex = this.apiQueryBatchSize;
			this.updateActiveTimelineItemDisplay(this.timelineIndex, newTimelineIndex);
			this.timelineIndex = newTimelineIndex;
		} else if (isOverEndOfTimeline && !isOldSlideLastStory) {
			this.queryForSlidesAndUpdateDotTemplate(this.resolve, this.apiQueryOperationTypeNext);
			// Set timeline index to first item.
			this.timelineIndex = 1;
		} else {
			this.updateActiveTimelineItemDisplay(this.timelineIndex, newTimelineIndex);

			// Set timeline index to selected item.
			this.timelineIndex = this.timelineIndex + indexChange;

			// Replace detail markup with the one of the currently selected slide.
			this.replaceDetailMarkupWithCurrentSlideMarkup();

			this.updateArrowUpDownDisplay();
		}
	},
	openDetail: function openDetail() {
		var _this3 = this;

		this.setLanguageNavigationLinksToStory();

		this.$ctx.addClass(this._states.stageSmall);
		this.$storyDetail.addClass(this._states.detailOpen);
		this.$stageData.fadeOut(this.storyOpenFadeInMilliseconds);
		this.$stageFooter.fadeOut(this.storyOpenFadeInMilliseconds);
		this.$stageImage.removeClass(this._states.zoomImage);
		this.$sliderStories.addClass(this._states.sliderScroll);

		this.$exploreStories = $('.' + this._selectors.exploreStories);
		this.$exploreStories.on('click', this.closeDetail.bind(this));

		// wait for add class width height auto because of animation detail-open
		setTimeout(function () {
			_this3.$sliderStories.addClass(_this3._states.sliderDetailOpen);
		}, this.storyOpenFadeInMilliseconds);

		this.$pageFooter.show();
		this.$footerTagList.show();

		this.getStoryComments();

		if (this.isOpenStory) {
			// Set isOpenStory to false after initial story was opened.
			this.isOpenStory = false;
		} else {
			/* Do not push to history or track Piwik event if direct access via story url.
   Since history change is not necessary. And page view ist tracked by Drupal. */
			this.pushCurrentStoryToHistory();
			this.trackStoriesPageView();
		}
	},
	getStoryComments: function getStoryComments() {
		var _this4 = this;

		var commentsRequestUrl = null;
		if (this.isFrontend()) {
			commentsRequestUrl = 'http://localhost:3000/slidesNext';
		} else {
			commentsRequestUrl = '/' + this.langcode + '/api/story/' + this.getCurrentSlide().storyId + '/comments?_format=json';
		}

		$.ajax({
			method: 'GET',
			url: commentsRequestUrl,
			dataType: 'json',
			success: function success(response) {
				_this4.storyCommentData = response;
				_this4.appendStoryCommentMarkup();
				if (_this4.shouldJumpToComments) {
					_this4.jumpToComments();
				}
			}
		});
	},
	appendStoryCommentMarkup: function appendStoryCommentMarkup() {
		var storyCommentContainer = this.$storyDetail.find('.' + this._selectors.storyCommentContainer);
		storyCommentContainer.empty();
		var commentMarkup = this.storyCommentData.commentMarkup;
		storyCommentContainer.append(commentMarkup);

		var storyCommentContainerElement = document.querySelector('.' + this._selectors.storyDetail + '\n\t\t.' + this._selectors.storyCommentContainer);
		this.initializeTerrificModulesInContainer(storyCommentContainerElement);
	},
	jumpToComments: function jumpToComments() {
		$('html, body').animate({
			scrollTop: $('.' + this._selectors.commentList).offset().top
		}, 180);
		this.shouldJumpToComments = false;
	},
	replaceInitialHistoryState: function replaceInitialHistoryState() {
		var stateVariables = {
			navigationType: 'javascript'
		};

		// Set activeOffset when reloading a stage page.
		if (this.isHistoryActiveSlideIndexSet()) {
			stateVariables.activeSlideIndex = window.history.state.activeOffset;
		}

		history.replaceState(stateVariables, document.title);
	},
	pushCurrentStoryToHistory: function pushCurrentStoryToHistory() {
		// Add current slide index data to active history entry before pushing new story history entry.
		history.replaceState({
			navigationType: 'javascript',
			activeOffset: this.currentOffset
		}, document.title);

		history.pushState({
			navigationType: 'javascript'
		}, this.getCurrentSlide().pageTitle, this.getCurrentSlide().storyLink[this.langcode]);
	},
	pushStageToHistory: function pushStageToHistory() {
		history.pushState({
			navigationType: 'javascript'
		}, this.stageTitle, this.stageUrl);
	},
	trackStoriesPageView: function trackStoriesPageView() {
		window._paq.push(['setCustomUrl', this.getCurrentSlide().storyLink[this.langcode]]);
		window._paq.push(['setDocumentTitle', this.getCurrentSlide().pageTitle]);
		window._paq.push(['trackPageView']);
	},
	trackBackToStagePageView: function trackBackToStagePageView() {
		window._paq.push(['setCustomUrl', this.stageUrl]);
		window._paq.push(['setDocumentTitle', this.stageTitle]);
		window._paq.push(['trackPageView']);
	},
	closeDetail: function closeDetail() {
		this.trackBackToStagePageView();
		this.pushStageToHistory();
		this.setLanguageNavigationLinksToStage();

		this.$sliderStories.removeClass(this._states.sliderDetailOpen);
		this.$storyDetail.removeClass(this._states.detailOpen);
		this.$ctx.removeClass(this._states.stageSmall);

		this.$sliderStories.removeClass(this._states.sliderScroll);
		this.$stageData.fadeIn(this.storyOpenFadeInMilliseconds);
		this.$stageFooter.fadeIn(this.storyOpenFadeInMilliseconds);
		this.$stageImage.addClass(this._states.zoomImage);
		this.$pageFooter.hide();
		this.$footerTagList.hide();

		this.storyCommentData = undefined;
	},
	setLanguageNavigationLinksToStage: function setLanguageNavigationLinksToStage() {
		for (var navigationLinkIndex = 0; navigationLinkIndex < this.$languageNavigationLinks.length; navigationLinkIndex++) {
			var languageLink = this.$languageNavigationLinks[navigationLinkIndex];
			var languageLinkLangcode = languageLink.dataset.langcode;

			languageLink.href = '/' + languageLinkLangcode;
		}
	},
	setLanguageNavigationLinksToStory: function setLanguageNavigationLinksToStory() {
		for (var navigationLinkIndex = 0; navigationLinkIndex < this.$languageNavigationLinks.length; navigationLinkIndex++) {
			var languageLink = this.$languageNavigationLinks[navigationLinkIndex];
			var languageLinkLangcode = languageLink.dataset.langcode;

			/* Use story link in language navigation.
   If no translation for story exists, use stage link as fallback. */
			if (typeof this.getCurrentSlide().storyLink[languageLinkLangcode] !== 'undefined') {
				languageLink.href = this.getCurrentSlide().storyLink[languageLinkLangcode];
			} else {
				languageLink.href = '/' + languageLinkLangcode;
			}
		}
	}
});